import styled from 'styled-components'

import { Reset } from '@/lib/mixins'

export const ProductDescriptionPreviewWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
`

export const ProductDescriptionPreviewText = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.2;
  color: ${props => props.theme.color.muted};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const ProductDescriptionPreviewMoreButton = styled.button`
  ${Reset('button')}
  color: ${props => props.theme.color.primaryDark};
  font-size: 0.95rem;
  line-height: 1.2;
  text-decoration: underline;
  white-space: nowrap;
  flex-shrink: 0;
`
